import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IMapFeature, PropertyMetadata } from "@tylertech/tyler-api-types";
import { AugmentedModelObject, RepositoryFormData } from "../../interfaces";
import { MetadataEventService, MetadataPropertyService } from "../../services";
import { Utilities } from "@tylertech/shared-module";
import { CustomViewService } from "@tylertech/custom-view";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

export interface SpatialMapBindingObject
{
    readonly propertyMetadata: PropertyMetadata;
    readonly metadataModel: AugmentedModelObject;
    readonly formRepository: RepositoryFormData;
    readonly parent: AugmentedModelObject;
    readonly model: IMapFeature[];
    updateMap: boolean;
    readonly callRecalculate: any;
}

@Component({
    selector: "metadata-spatial-map",
    templateUrl: "./metadataSpatialMap.tmpl.html",
    standalone: false
})
export class MetadataSpatialMapComponent implements OnInit
{
    @Input() propertyMetadata: PropertyMetadata;
    @Input() metadataModel: AugmentedModelObject;
    @Input() formRepository: RepositoryFormData;
    @Input() parent: AugmentedModelObject;
    @Input() model: IMapFeature[];

    customDataBinding: SpatialMapBindingObject;

    mapComponent: any;

    constructor(
        private readonly $metadataPropertyService: MetadataPropertyService,
        private readonly $metadataEventService: MetadataEventService,
        private readonly $customViewService: CustomViewService
    )
    {
        const self = this;
        self.$metadataEventService.onRecalculateWorking.pipe(takeUntilDestroyed())
            .subscribe(args =>
            {
                if (!args.Recalculating)
                {
                    self.customDataBinding.updateMap = true;
                    requestAnimationFrame(() =>
                    {
                        self.customDataBinding.updateMap = false;
                    });
                }
            });
    }

    ngOnInit()
    {
        this.customDataBinding = {
            propertyMetadata: this.propertyMetadata,
            metadataModel: this.metadataModel,
            formRepository: this.formRepository,
            parent: this.parent,
            model: this.model,
            updateMap: false,
            callRecalculate: this.callRecalculateBind()
        };
        this.mapComponent = this.$customViewService.getView("spatial-map").component;
    }

    private _callRecalculateBind: any;

    callRecalculateBind(): unknown
    {
        if (!this._callRecalculateBind)
        {
            this._callRecalculateBind = (arg: any) => this.callRecalculate(arg);
        }
        return this._callRecalculateBind;
    }


    callRecalculate($event: any): void
    {
        const self = this;
        const originalData = self.metadataModel[self.propertyMetadata.Name];
        let featureAsArray: IMapFeature[];
        if ($event.feature != null)
        {
            featureAsArray = [$event.feature];
        }
        else
        {
            featureAsArray = $event.features;
        }

        let type = self.metadataModel.$$TypeName;
        if (!type && self.formRepository) type = self.formRepository.Type;
        self.$metadataPropertyService.recalculateProperties(
            type,
            self.propertyMetadata,
            self.metadataModel,
            self.parent,
            featureAsArray,
            undefined,
            true,
            true,
            self.formRepository
        ).then(_x => self.metadataModel[self.propertyMetadata.Name] = originalData);
    }
}
